import {ReactNode} from "react";
import {IconType} from "react-icons";
import {FaBookReader} from "react-icons/fa";
import {FaRocket, FaYoutube} from "react-icons/fa6";

import {FeatureBlock} from "@/pages/launchpad/FeatureBlock.tsx";

const supportDef: {
  title: string;
  subtitle: string;
  icon: IconType;
  accessory: ReactNode;
}[] = [
  {
    title: "Quickstart Guide",
    subtitle: "Review the basics and get up to speed with Uptime.com monitoring and account setup.",
    icon: FaRocket,
    accessory: (
      <a
        className="title"
        href="https://support.uptime.com/hc/en-us/articles/360001311220-Getting-Started-With-Uptime-com"
        target="_blank"
      >
        Get Started
      </a>
    ),
  },
  {
    title: "Documentation",
    subtitle: "View setup instructions for checks, integrations, status pages and more from our support documentation.",
    icon: FaBookReader,
    accessory: (
      <a className="title" href="https://support.uptime.com" target="_blank">
        Find Answers
      </a>
    ),
  },
  {
    title: "Uptime.com Video Tutorials",
    subtitle: "Browse a growing library of video resources.",
    icon: FaYoutube,
    accessory: (
      <a className="title" href="https://www.youtube.com/channel/UCFSfPCnC0x08CPobke0vEHA/featured" target="_blank">
        View Video Library
      </a>
    ),
  },
];

export const Support = () => (
  <div>
    <div className="row mb-4">
      <h5>Support</h5>
    </div>
    <div className="row">
      {supportDef.map((f, idx) => (
        <div className="col-12 col-sm-6 col-lg-4 mb-4" key={idx}>
          <FeatureBlock title={f.title} subtitle={f.subtitle} icon={f.icon} accessory={f.accessory} />
        </div>
      ))}
    </div>
  </div>
);
